import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
// import AssetTemplateModel from '../../Models/AssetTemplateModel';
import { loadingDispatch } from '../../app/utils';
import { notify } from '../../AppSlice';

import {
  Autocomplete,
  Button as MuiButton,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  MenuItem
} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import bgImage from '../../assets/NewUserBackground.png';
import ClearIcon from '@mui/icons-material/Clear';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

type Props = {
  open: boolean;
  onClose: () => void;
};

function NewUser({ onClose, open }: Props) {
  const [label, setLabel] = useState('');
  const [description, setDescription] = useState('');
  const [modelId, setModelId] = useState('');
  const [tags, setTags] = useState<string[]>([]);

  const handleTagDelete = (removedTag: string) => {
    const newTags = tags.filter((tag) => tag !== removedTag);
    setTags(newTags);
  };

  return (
    <>
      <Dialog
        PaperProps={{
          style: {
            backgroundColor: 'var(--color-sand-dark)',
            backgroundImage: `url(${bgImage})`,
            backgroundSize: 'cover',
            boxShadow: 'none',
            border: '1px solid var(--color-offwhite)',
            borderRadius: 10,
            maxHeight: '500px',
            height: '100%'
          }
        }}
        fullWidth
        maxWidth="md"
        open={open}
        onClose={onClose}
      >
        <DialogTitle
          className="bold-text"
          fontSize={32}
          textAlign="center"
          color="var(--color-sand-secondary)"
        >
          ADD NEW USER
        </DialogTitle>
        <DialogContent>
          <Grid px={5}>
            <Typography
              sx={{ color: 'var(--color-sand-highlight)' }}
              fontSize={28}
              variant="h4"
              mb={1}
            >
              User Details
            </Typography>
          </Grid>
          <Grid px={5} container spacing={4}>
            <Grid flexDirection="row" xs={6}>
              <TextField
                id="user-firstname"
                required
                className="sand"
                label="First Name"
                variant="outlined"
                fullWidth
                InputLabelProps={{
                  shrink: true
                }}
                value={label}
                onChange={(e) => {
                  setLabel(e.target.value);
                }}
                sx={{
                  textArea: { color: 'white' }
                }}
                margin="normal"
              />
            </Grid>

            <Grid flexDirection="row" xs={6}>
              <TextField
                id="user-lastname"
                required
                className="sand"
                label="Last Name"
                variant="outlined"
                fullWidth
                InputLabelProps={{
                  shrink: true
                }}
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                }}
                sx={{
                  textArea: { color: 'white' }
                }}
                margin="normal"
              />
            </Grid>
          </Grid>
          <Grid px={5}>
            <TextField
              id="user-email"
              required
              className="sand"
              label="Rio Tinto Email"
              variant="outlined"
              fullWidth
              InputLabelProps={{
                shrink: true
              }}
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
              }}
              sx={{
                textArea: { color: 'white' }
              }}
              margin="normal"
            />
          </Grid>
        </DialogContent>
        <DialogActions>
          <MuiButton
            variant="outlined"
            className="sand secondary-button bold-text"
            size="large"
            onClick={onClose}
            type="button"
          >
            Cancel
          </MuiButton>
          <MuiButton
            variant="contained"
            className="sand primary-button bold-text"
            size="large"
            onClick={(e) => {
              onClose();
            }}
            type="submit"
          >
            Submit
          </MuiButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default NewUser;
